import { get } from 'lodash'
import ArticleTagListTag from '@theme/components/content/ArticleTagListTag'

export default {
  components: {
    ArticleTagListTag,
  },
  props: {
    tags: {
      type: Array,
      default() {
        function getLinks(items) {
          let output = []
          items.forEach(i => {
            if (i.__typename === 'article_tag') {
              output.push({
                article_tag_link: [
                  {
                    entity: i,
                  },
                ],
                link_type: i.__typename,
                title: i.title,
              })
            }
          })
          return output
        }
        return get(this.$store.state, 'article.configuration_article_list.tags.length')
          ? this.$store.state.article.configuration_article_list.tags.map(item => item.entity)
          : getLinks(get(this.$store.state, 'article.tags') || []) || []
      },
    },
  },
}
